
export const getList = <T>(state: State<T>): Array<T> => state.list